export default __webpack_public_path__ + "images/animoto-plans-pricing.0a99a35bd4b4de133aac8e4c02ce1798.png";